import { render, staticRenderFns } from "./ValueBadge.vue?vue&type=template&id=b28a9208&scoped=true"
import script from "./ValueBadge.vue?vue&type=script&lang=ts"
export * from "./ValueBadge.vue?vue&type=script&lang=ts"
import style0 from "./ValueBadge.vue?vue&type=style&index=0&id=b28a9208&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28a9208",
  null
  
)

export default component.exports